<script lang="ts">
  import KeyboardHint from '$icons/KeyboardHintIcon.svelte';
  import { createEventDispatcher, onMount } from 'svelte';
  import Modal from '../Modals/SmallModal/Modal.svelte';
  import type { FPost } from 'garden-common';
  import Input from '$lib/components/common/inputs/textInputs/DebouncedTextInputWithLeftIcon.svelte';
  import type { WithCreatorData } from 'garden-common';
  import { userWalletDetails } from '$utils/api/wallet.util';
  import { me } from '$stores/user.store';
  import Button from '../common/buttons/Button.svelte';

  export let post: Partial<FPost<string>> & Partial<WithCreatorData>;
  export let minimumSeed = 0;

  let seed: string = '';
  let wallet: any; //:( `any` bad
  let state: 'Continue' | 'Send Seed' | 'Close' = 'Continue';
  let isInvalid: boolean;
  let isInvalidReason: string;

  const dispatch = createEventDispatcher();

  onMount(async () => {
    wallet = await userWalletDetails($me._id);
  });

  function checkValidity() {
    if (isNaN(+seed) || +seed < 0) {
      isInvalid = true;
      isInvalidReason = 'SEED value must be a number';
      return;
    }

    if (+seed > wallet?.seedAmount) {
      isInvalid = true;
      isInvalidReason = 'You do not have that much SEED';
      return;
    }

    if (+seed < minimumSeed) {
      isInvalid = true;
      isInvalidReason = `Minimum ${minimumSeed} SEED required`;
      return;
    }

    isInvalid = false;
    isInvalidReason = '';
  }

  $: seed, checkValidity();
</script>

<Modal on:ModalClose footerBorder class="w-[560px]">
  <div slot="header">
    <div class="text-blueish-grey-900 font-bold text-2xl">
      {#if state === 'Continue'}
        Place your donation
      {:else if state === 'Send Seed'}
        Confirm donation amount
      {:else}
        Your donation has been sent!
      {/if}
    </div>

    <div class="text-garden-grey-400 text-sm w-[60%] mt-2">
      {#if state === 'Continue'}
        Donate seeds to show appreciation for talents. Seeds are the highest form of appreciation on
        The Garden!
      {:else if state === 'Send Seed'}
        Confirm donation amount
      {:else}
        Your donation has been sent!
      {/if}
    </div>
  </div>

  <div slot="content" class="content-step-request overflow-y-clip p-5">
    {#if state == 'Continue'}
      <div class="mb-3">
        <Input dangerMessage={isInvalidReason} danger={isInvalid} label="Amount" bind:value={seed}>
          <svg
            width="20"
            height="22"
            viewBox="0 0 20 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M9.67753 16.6763C11.3885 16.0566 10.7927 14.9443 10.7163 13.7049C12.354 13.2855 13.5374 15.5111 13.9244 16.6763C14.0059 17.7621 13.9977 20.0258 11.419 20.7123C8.19569 21.5703 7.96655 17.296 9.67753 16.6763Z"
              fill="white"
            />
            <path
              d="M11.6001 3.20541C14.6554 0.758413 17.0844 2.2997 19.3759 3.45964C19.9259 7.09836 16.9928 9.16401 15.3429 8.51253C13.693 7.86106 12.5931 7.67038 11.371 8.51253C10.1489 9.35468 10.0266 10.7371 10.2558 12.8345C7.44491 9.92671 8.54482 5.65241 11.6001 3.20541Z"
              fill="#82DC1F"
            />
            <path
              d="M5.75854 2.17125C8.30973 2.15536 9.2416 3.83966 9.85266 4.72948C9.08883 5.74641 8.92079 6.04831 8.55415 7.4466C7.40841 6.3661 6.1099 6.8269 4.90305 7.95506C3.6962 9.08322 0.0145506 8.0504 0.472848 5.85764C0.931145 3.66487 3.20735 2.18714 5.75854 2.17125Z"
              fill="#74CE00"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M14.0319 1.0718C12.5601 1.30193 11.2836 1.98688 10.1834 3.13666L9.75471 3.58471L9.54175 3.29108C7.11233 -0.0589874 1.99056 0.578743 0.287603 4.44336C-0.0957573 5.31333 -0.0957962 5.47146 0.287058 6.31732C1.26451 8.47688 3.90257 9.00242 5.53324 7.36241C6.32815 6.56294 7.32598 6.48198 8.05541 7.15786L8.18199 7.27513L8.13824 7.64992C7.96278 9.15267 8.37997 11.0677 9.16641 12.3696C9.48408 12.8954 9.9241 13.0118 10.3632 12.686C10.7013 12.435 10.7369 12.1081 10.5208 11.2372C9.9376 8.88757 11.9734 7.06049 14.0537 8.06636C16.8763 9.43106 20.1405 6.62003 19.523 3.3565C19.3892 2.64931 19.3728 2.61553 19.0397 2.36322C17.6119 1.28173 15.7538 0.802578 14.0319 1.0718ZM16.0861 1.90476C16.9634 2.06896 18.1329 2.5935 18.5887 3.02731C18.949 3.37016 18.8984 4.7464 18.4921 5.65102C17.7538 7.29524 15.8419 8.05832 14.3319 7.31144C12.495 6.40282 10.397 7.37528 9.78344 9.41977C9.55898 10.1677 9.57034 10.6836 9.83287 11.6675C9.99169 12.2626 9.87277 12.1483 9.50885 11.3562C8.88579 10 8.6964 8.57433 9.02473 7.71238C10.0896 4.91689 12.4131 3.60474 15.5622 4.02038C15.8842 4.0629 15.9702 4.06298 16.003 4.02067C16.0698 3.93439 16.0108 3.88908 15.6903 3.78064C13.1353 2.91633 9.97629 4.45552 9.05756 7.0124C8.93689 7.34821 8.93634 7.29158 9.05542 6.79114C9.84983 3.45186 12.9267 1.31342 16.0861 1.90476ZM6.40242 2.06334C7.46936 2.36063 8.56893 3.16344 9.13067 4.05524L9.27965 4.29177L9.20195 4.40921C9.15921 4.4738 9.06312 4.64508 8.98841 4.78979L8.85258 5.05294L8.76819 4.93554C7.51673 3.19434 5.14077 2.83708 3.61554 4.16076C3.08818 4.61843 3.22187 4.69418 3.91206 4.32884C5.88097 3.28662 7.27263 3.48789 8.53715 4.99776L8.75664 5.25978L8.607 5.65206C8.52471 5.86782 8.43857 6.11918 8.41559 6.21063L8.37378 6.37687L8.12525 6.23058C7.13955 5.6504 6.00289 5.81406 5.13712 6.66084C3.65054 8.11487 1.47673 7.61427 0.846232 5.67272C0.733417 5.32545 0.739989 5.28672 1.00851 4.71404C1.99048 2.61999 4.30981 1.4802 6.40242 2.06334ZM10.6386 12.8594C10.2583 13.0624 10.138 13.4491 10.2951 13.9643C10.577 14.8893 10.3993 15.5028 9.79546 15.6886C8.07411 16.2184 7.3455 18.2647 8.31961 19.8338C9.64555 21.9696 13.0622 21.0165 13.929 18.2691C14.5196 16.3972 13.8688 14.591 12.1618 13.3644C11.2999 12.7451 11.0241 12.6537 10.6386 12.8594ZM11.3043 13.7488C11.6652 13.9747 12.1237 14.3266 12.3883 14.5809C14.2189 16.3397 13.365 19.6046 10.9346 20.1395C8.51122 20.6728 7.68352 17.2545 10.043 16.4575C10.5019 16.3024 10.841 15.9815 11.0549 15.4997C11.1964 15.1808 11.2033 14.2527 11.0669 13.8563C11.02 13.7196 10.9816 13.6025 10.9816 13.596C10.9816 13.5601 11.0683 13.6011 11.3043 13.7488Z"
              fill="black"
            />
          </svg>
        </Input>
      </div>
      <div class="flex items-center justify-between flex-wrap gap-2">
        <div class="flex items-end gap-2">
          {#each [15, 50, 100, 500, 1000] as n}
            <button
              on:click={() => (seed = String(n))}
              class="flex h-9 px-3 py-2 bg-gray-100 rounded-[30px] justify-center items-center gap-1"
            >
              {n}
            </button>
          {/each}
        </div>

        <div
          class=" px-3 py-2 bg-stone-50 rounded-[30px] justify-center items-center gap-1 inline-flex"
        >
          <div class="w-4 h-4 justify-center items-center flex">
            <div class="w-4 h-4 relative">
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M14.6675 7.31333V8.68666C14.6675 9.05333 14.3741 9.35333 14.0008 9.36666H12.6941C11.9741 9.36666 11.3141 8.84 11.2541 8.12C11.2141 7.7 11.3741 7.30666 11.6541 7.03333C11.9008 6.78 12.2408 6.63333 12.6141 6.63333H14.0008C14.3741 6.64666 14.6675 6.94666 14.6675 7.31333Z"
                  fill="#5B6673"
                />
                <path
                  d="M13.6473 10.3667H12.694C11.4273 10.3667 10.3607 9.41334 10.254 8.2C10.194 7.50667 10.4473 6.81334 10.954 6.32C11.3807 5.88 11.974 5.63334 12.614 5.63334H13.6473C13.8407 5.63334 14.0007 5.47334 13.9807 5.28C13.834 3.66 12.7607 2.55334 11.1673 2.36667C11.0073 2.34 10.8407 2.33334 10.6673 2.33334H4.66732C4.48065 2.33334 4.30065 2.34667 4.12732 2.37334C2.42732 2.58667 1.33398 3.85334 1.33398 5.66667V10.3333C1.33398 12.1733 2.82732 13.6667 4.66732 13.6667H10.6673C12.534 13.6667 13.8207 12.5 13.9807 10.72C14.0007 10.5267 13.8407 10.3667 13.6473 10.3667ZM8.66732 6.5H4.66732C4.39398 6.5 4.16732 6.27334 4.16732 6C4.16732 5.72667 4.39398 5.5 4.66732 5.5H8.66732C8.94065 5.5 9.16732 5.72667 9.16732 6C9.16732 6.27334 8.94065 6.5 8.66732 6.5Z"
                  fill="#5B6673"
                />
              </svg>
            </div>
          </div>
          <div>
            <span class="text-gray-500 text-sm font-medium leading-tight">Balance: </span>
            <span class="text-green-500 text-sm font-medium leading-tight"
              >{wallet?.seedAmount.toLocaleString() || ' '} SEED</span
            >
          </div>
        </div>
      </div>
    {:else if state == 'Send Seed'}
      <div class="flex justify-center items-center gap-6">
        <div
          class="px-[49px] py-8 bg-blueish-grey-100 rounded-2xl flex-col justify-start items-start gap-2 inline-flex"
        >
          <div class="flex-col justify-start items-center gap-1 flex">
            <div class="text-blue-950 text-base font-bold leading-tight">Donate</div>
            <div
              class="text-green-600 text-2xl font-bold leading-loose break-keep whitespace-nowrap"
            >
              {seed} SEED
            </div>
          </div>
        </div>
        <div class="justify-start items-start flex">
          <div class="opacity-50 justify-center items-center flex">
            <div class="relative">
              <svg
                width="56"
                height="24"
                viewBox="0 0 56 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g opacity="0.4">
                  <path
                    d="M8.91016 19.92L15.4302 13.4C16.2002 12.63 16.2002 11.37 15.4302 10.6L8.91016 4.08"
                    stroke="#0F9D58"
                    stroke-width="1.5"
                    stroke-miterlimit="10"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </g>
                <g opacity="0.6">
                  <path
                    d="M24.9102 19.92L31.4302 13.4C32.2002 12.63 32.2002 11.37 31.4302 10.6L24.9102 4.08"
                    stroke="#0F9D58"
                    stroke-width="1.5"
                    stroke-miterlimit="10"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </g>
                <path
                  d="M40.9102 19.92L47.4302 13.4C48.2002 12.63 48.2002 11.37 47.4302 10.6L40.9102 4.08"
                  stroke="#0F9D58"
                  stroke-width="1.5"
                  stroke-miterlimit="10"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
          </div>
        </div>
        <div
          class="px-[55px] py-8 bg-blueish-grey-100 rounded-2xl flex-col justify-start items-start gap-2 inline-flex"
        >
          <div class="flex-col justify-start items-center gap-1 flex">
            {#if post.creatorData.profileImage}
              <img
                class="w-12 h-12 rounded-[32px]"
                alt="Avatar"
                src={post.creatorData.profileImage}
              />
            {:else}
              <img
                src={`https://api.dicebear.com/6.x/thumbs/svg?backgroundColor=B5F1D4&shapeColor=074D2B&seed=${post.creatorData?.userName}`}
                class="w-12 h-12 rounded-[32px]"
                alt="Avatar"
              />
            {/if}
            <div class="text-blue-950 text-base font-bold leading-tight">
              {post.creatorData.userName}
            </div>
          </div>
        </div>
      </div>
    {:else if state == 'Close'}
      <div class="flex flex-col justify-center items-center">
        <div class="flex justify-center items-center relative">
          <div class="mr-[60px]">
            <svg
              width="138"
              height="138"
              viewBox="0 0 138 138"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle opacity="0.5" cx="69.0004" cy="69" r="57.932" fill="#0F9D58" />
              <circle opacity="0.2" cx="69" cy="69" r="68.3301" fill="#0F9D58" />
              <circle cx="69" cy="69" r="51" fill="#0F9D58" />
              <path
                d="M50.6797 68.7524L64.5438 82.6165L90.7865 56.3738"
                stroke="white"
                stroke-width="12"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
          <div class="absolute right-[15px]">
            {#if post.creatorData.profileImage}
              <img
                class="w-[102px] h-[102px] rounded-full"
                alt="Avatar"
                src={post.creatorData.profileImage}
              />
            {:else}
              <img
                src={`https://api.dicebear.com/6.x/thumbs/svg?backgroundColor=B5F1D4&shapeColor=074D2B&seed=${post.creatorData?.userName}`}
                class="w-[102px] h-[102px] rounded-full"
                alt="Avatar"
              />
            {/if}
          </div>
        </div>
        <div class="justify-start items-center gap-[5px] inline-flex mt-3">
          <div class="text-blue-950 text-base font-bold leading-tight">
            {post.creatorData.userName}
          </div>
          <div class="text-slate-500 text-base font-medium leading-normal">received</div>
          <div class="text-green-600 text-base font-bold leading-tight">{seed} Seeds</div>
        </div>
        <div class="flex-col justify-start items-center gap-2 inline-flex">
          <div class="text-center text-slate-400 text-sm font-medium leading-tight">
            {wallet?._id || 'Loading...'}
          </div>
          <div class="w-4 h-4 justify-center items-center inline-flex">
            <div class="w-4 h-4 relative">
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12.0465 9.62L7.99979 13.6667L3.95312 9.62"
                  stroke="#AAB8C8"
                  stroke-width="1.5"
                  stroke-miterlimit="10"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M8 2.33334V13.5533"
                  stroke="#AAB8C8"
                  stroke-width="1.5"
                  stroke-miterlimit="10"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
          </div>
          <div class="text-center text-slate-400 text-sm font-medium leading-tight">
            {post?.creator}
          </div>
        </div>
      </div>
    {/if}
  </div>

  <div slot="footer" class="w-full flex justify-end gap-2 pt-6">
    {#if state == 'Continue' || state !== 'Close'}
      <Button
        secondary
        label={state == 'Send Seed' ? 'Back' : 'Close'}
        on:click={() => {
          if (state !== 'Send Seed') {
            dispatch('ModalClose');
          } else {
            state = 'Continue';
          }
        }} />
    {/if}
    <Button
      primary
      clickOnKey={"Enter"}
      on:click={() => {
        if (state == 'Continue') {
          state = 'Send Seed';
        } else if (state == 'Send Seed') {
          state = 'Close';
          dispatch('Donate', seed);
        } else if (state == 'Close') {
          dispatch('ModalClose');
        }
      }}
      disabled={seed.length == 0 || seed > wallet?.seedAmount || isInvalid}
      label={state}
      iconRight={KeyboardHint}
    />
  </div>
</Modal>

<style type="postcss">
  .content-step-request {
    @apply h-auto mb-10 pt-10;
  }
</style>
